import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import IconButton from "@mui/material/IconButton";

function RightArrow({ onClick }) {
    return (
        <IconButton sx={{position: 'absolute', right: {xs: '-10px', md: 0}}} onClick={onClick}>
            <ChevronRightIcon></ChevronRightIcon>
        </IconButton>
    );
}

export default RightArrow;
